<template>
  <div
    class="browsing-tag"
    :class="{ 'is-selected': isSelected, disabled: disabled }"
    @click="clickTag(name)"
  >
    <img :src="src" class="icon" />
    <div class="label" :class="{ 'is-underlined': isSelected }">{{ title }}</div>
      <div v-if="title==='Free' && isSelected" class="tag-choices">
            <div class="sub-tag"
            :class="{ 'is-selected': selectPdf }" 
            @click.prevent.stop="clickTag('pdf')">
            <img src="/images/browse-tags/pdf.png" class="icon" />
            PDF</div>
            <div class="sub-tag" 
            :class="{ 'is-selected': selectEpub }" 
            @click.prevent.stop="clickTag('epub')">
            <img src="/images/browse-tags/epub.png" class="icon" />
            ePub</div>
      </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "BrowsingTags",
  props: ["name", "onClick", "isSelected", "selectPdf", "selectEpub"],
  data: function () {
    return {
      tags: [
        "free",
        "kindle-unlimited",
        "verified-purchase",
        "quick-read",
        "most-snaps",
        "pdf",
        "epub",
        // "business",
        // "self-help",
        // "healthy-living",
        // "professional",
        // "romance",
      ],
    };
  },
  computed: {
    ...mapState({
      user: "user",
    }),
    title() {
      name = this.name.replace(/-+/g, " ");
      const words = name.split(" ");

      return words
        .map((word) => {
          return word[0].toUpperCase() + word.substring(1);
        })
        .join(" ");
    },
    src() {
      return "/images/browse-tags/" + this.name + ".png";
    },
    disabled() {
      if (this.user.is_vp_suspended_reader) {
        return (this.name === "verified-purchase")
      }
      return false;
    }
  },
  methods: {
    clickTag(tagName) {
        this.onClick(tagName)
    },

    nametoTitle(name) {
      return name;
      name = name.replace(/-+/g, " ");
      return name.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.browsing-tag {
  display: flex;
  padding: 10px 18px 9px 18px;
  margin: 4px;
  border: 2px solid #f2ece3;
  border-radius: 20px;
  font-size: 13.5pt;
  font-weight: 500;
  font-family: $font-family;
  cursor: pointer;

  .icon {
    height: 32px;
    margin: -2px 8px 0 0;
  }

  .label {

  }
}

.browsing-tag.is-selected {
  font-weight: 500;
  //text-decoration: underline;
  border: 2px solid darken(#f7af3c, 0%) !important;
}

.is-underlined {
  text-decoration: underline;
}

.browsing-tag:hover {
  border: 2px solid lighten(#f7af3c, 20%);
}

.tag-choices {
  display: flex;
  padding: 0px 0px 0px 0px;
  margin-left: 8px;
}

.sub-tag {
  display: inline-block;
  padding: 3px 9px 3px 9px;
  margin: 2px;
  border: 2px solid #f2ece3;
  border-radius: 10px;
  text-decoration:none;
  font-size: 11pt;
  font-weight: 500;
  font-family: $font-family;
  cursor: pointer;

  .icon {
    height: 22px;
    margin: -1px 2px -4px 0;
  }
}

.sub-tag.is-selected {
  font-weight: 500;
  text-decoration: underline;
  border: 2px solid darken(#f7af3c, 0%) !important;
}
.sub-tag:hover {
  border: 2px solid lighten(#f7af3c, 20%);
}

.disabled {
  background: #f4f4f4 !important;
  color: #aaa !important;
  pointer-events: none !important;
  
  .icon {
    background: #f4f4f4;
    border-radius: 60%;
    filter: grayscale(1);
  }
}

@media (max-width: 1024px) {
  .browsing-tag {
    padding: 6px 12px 6px 12px;
    font-size: 12pt;
  }
}
</style>
